// @ts-ignore
export default function (value) {
    if (!value || !value.nombre || !value.apellido_paterno) return;
    let nombre = value.nombre[0];
    let apellido_paterno = value.apellido_paterno[0];
    return nombre + apellido_paterno;
}